<template>
  <div class="student-side-menu">
    <div class="user-info">
      <a-avatar
        style="backgroundcolor: #87d068"
        shape="square"
        icon="user"
        :src="avatarUrl"
      />
      <h3>{{ $store.state.user.info.realname }}</h3>
      <!-- <p>优秀作业 {{userCountInfo.workGreatTotal}}</p>
      <p>(作业总数 {{userCountInfo.workTotal}})</p> -->
    </div>
    <a-divider style="width: 80%"></a-divider>
    <div>
      <a-menu mode="inline" @click="handleClick" v-model="selectedKeys">
        <a-menu-item v-if="studentMenu.includes('center')" :key="this.$store.state.user.info.userIdentity==2?'teacherIndex':'userIndex'"
          ><router-link :to="this.$store.state.user.info.userIdentity==2?'/teacher/index':'/user/index'"
            ><a-icon type="dashboard" />个人中心</router-link
          ></a-menu-item
        >
        <a-menu-item v-if="studentMenu.includes('course')" key="userCourse"
          ><router-link to="/user/course"
            ><a-icon type="calculator" />我的课程</router-link
          ></a-menu-item
        >
        <a-menu-item v-if="studentMenu.includes('vip')" key="Vip"
        ><router-link to="/user/Vip"
        ><a-icon type="crown" />会员中心</router-link
        ></a-menu-item
        >
        <a-menu-item v-if="studentMenu.includes('departWork')" key="userAdditionWork"
          ><router-link to="/user/additionalWork"
            ><a-icon type="edit" />我的作业</router-link
          ></a-menu-item
        >
        <a-menu-item v-if="studentMenu.includes('eventApply')" key="userEvent"
          ><router-link to="/user/event"
            ><a-icon type="fire" />我的活动</router-link
          ></a-menu-item
        >
        <a-menu-item v-if="studentMenu.includes('examine')" key="myPaper"
          ><router-link to="/user/myPaper"
            ><a-icon type="ordered-list" />我的考试</router-link
          ></a-menu-item
        >
        <a-menu-item v-if="studentMenu.includes('question')" key="myQuestion"
          ><router-link to="/user/question"
            ><a-icon type="ordered-list" />OJ 练习</router-link
          ></a-menu-item
        >
        <a-menu-item v-if="studentMenu.includes('work')" key="userWork"
          ><router-link to="/user/work"
            ><a-icon type="code" />我的创作</router-link
          ></a-menu-item
        >
        <a-menu-item v-if="studentMenu.includes('attention')" key="attention"
          ><router-link to="/user/attention"
            ><a-icon type="user" />我的关注</router-link
          ></a-menu-item
        >
        <a-menu-item v-if="studentMenu.includes('collect')" key="collect"
          ><router-link to="/user/collect"
            ><a-icon type="star" />我的收藏</router-link
          ></a-menu-item
        >
        <a-menu-item v-if="studentMenu.includes('info')" key="userInfo"
          ><router-link to="/user/info"
            ><a-icon type="contacts" />个人信息</router-link
          ></a-menu-item
        >
        <a-menu-item v-if="studentMenu.includes('setting')" key="userSetting"
          ><router-link to="/user/setting"
            ><a-icon type="setting" />安全设置</router-link
          ></a-menu-item
        >
        <a-menu-item v-if="studentMenu.includes('backend') && $store.getters.tenantInfo.backendUrl" key="home"
          ><a @click="toBackend"><a-icon type="home" />个人空间</a></a-menu-item
        >
        <a-menu-item v-if="studentMenu.includes('hoj') && $store.getters.tenantInfo.hojUrl" key="hoj"
          ><a @click="toHoj"><a-icon type="project" />HOJ 系统</a></a-menu-item
        >
      </a-menu>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { getAction } from "@/api/manage";
import { TENANT_CONFIG, ACCESS_TOKEN } from "@/store/mutation-types";
import { getQiniuUrl } from "@/utils/qiniu.js";

export default {
  name: "SideMenuStudent",
  data() {
    return {
      selectedKeys: ["course"],
      userCountInfo: {},
      token: "",
      studentMenu:[]
    };
  },
  computed: {
    avatarUrl() {
      if (this.$store.state.user.avatar) {
        return this.$store.state.user.avatar;
      } else if (
        this.$store.state.user.info &&
        this.$store.state.user.info.avatar
      ) {
        return this.$store.state.user.info.avatar;
      } else {
        return "/img/avatar.png";
      }
    },
  },
  created() {
    this.selectedKeys[0] = this.$route.name;
    console.log(this.selectedKeys);
    this.token = Vue.ls.get(ACCESS_TOKEN);
    let jsonStudentMenu = this.$store.getters.tenantInfo['json_studentMenu']
    if(jsonStudentMenu){
      this.studentMenu = JSON.parse(jsonStudentMenu)
    }
    
  },
  methods: {
    getQiniuUrl,
    toBackend() {
      if(this.$store.getters.tenantInfo.backendUrl){
        window.location.href = this.$store.getters.tenantInfo.backendUrl + "/dashboard/index?token=" + this.token;
      }else{
        alert('暂未开放')
      }
    },
    toHoj(){
      if(this.$store.getters.tenantInfo.hojUrl){
        let url = this.$store.getters.tenantInfo.hojUrl + "/?teachingtoken=" + this.token;
        window.open(url)
      }else{
        alert('暂未开放')
      }
    },
    handleClick(e) {},
  },
};
</script>

<style lang="less" scoped>
.student-side-menu {
  padding-bottom: 20px;
}
.user-info {
  background-image: url("~@assets/theme/xmw/user-info-bg.png");
  background-size: cover;
  padding-top: 50px;
  .school-area {
    font-size: 14px;
    color: #999;
  }
  .medal {
    width: 40px;
    margin-bottom: 10px;
  }
}
.ant-avatar {
  width: 80px;
  height: 80px;
  padding: 5px;
  background: #fff !important;
}
.ant-menu-item {
  a,
  i {
    font-size: 18px;
  }
}
</style>